import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesNoteRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases-note',
	path: '/secure/ReleaseNote.jspa',
	query: ['projectId', 'version'],
};
